// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7172428c","284":"de9f4edc","626":"8e09a93b","667":"2a03a156","977":"6e7599cf"}[chunkId] + ".chunk.js";
};